import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function BellOffIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M9.222 14H6.778M5.942 2.653A3.6 3.6 0 0 1 8 2c.972 0 1.905.4 2.593 1.11a3.86 3.86 0 0 1 1.074 2.68c0 1.326.165 2.369.396 3.178M4.49 4.688a4 4 0 0 0-.158 1.101c0 1.952-.476 3.288-1.008 4.172-.45.746-.674 1.119-.665 1.223.009.115.032.159.122.228.081.062.447.062 1.178.062h7.096M13.5 14 2.5 2.632" /></svg>
  );
}

export default BellOffIcon;
